export default "__VITE_ASSET__D8T5d2FK__"